import React, { Suspense } from 'react'

// This component is used to split hydration of the app (which normally freezes
// the page for a few hundred milliseconds) into smaller non-blocking chunks.
// See https://3perf.com/talks/react-concurrency/#suspense for how it works.
// fallback is the loading animation
//
// Note: as of May 2024, HydrationSplitter is disabled while we’re testing
// React event blocking in plugins/gatsby-perf-hydrate-starttransition/gatsby-browser.js
export default function HydrationSplitter({ children }) {
  return children
}
